import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Plus, Trash } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Admin = () => {
  const [beats, setBeats] = useState([]);
  const [formData, setFormData] = useState({
    title: '', price: 29.99, bpm: 120, key: '', 
    audio_url: '', cover_image: '', tags: ''
  });

  const fetchBeats = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/beats`);
      setBeats(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const token = localStorage.getItem('token');

  // Check role using backend to be safe
  useEffect(() => {
    const checkRole = async () => {
        try {
            if (!token) throw new Error("No token");
            const res = await axios.get(`${BACKEND_URL}/api/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.role !== 'admin') {
                window.location.href = '/';
            } else {
                fetchBeats();
            }
        } catch (e) {
            window.location.href = '/';
        }
    };
    checkRole();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const tagsArray = formData.tags.split(',').map(t => t.trim());
      await axios.post(
        `${BACKEND_URL}/api/beats`, 
        { ...formData, tags: tagsArray },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Beat ajouté !");
      setFormData({
        title: '', price: 29.99, bpm: 120, key: '', 
        audio_url: '', cover_image: '', tags: ''
      });
      fetchBeats();
    } catch (e) {
      toast.error("Erreur lors de l'ajout");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce beat ?")) return;
    try {
      await axios.delete(`${BACKEND_URL}/api/beats/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Beat supprimé");
      fetchBeats();
    } catch (e) {
      toast.error("Erreur suppression");
    }
  };

  return (
    <div className="pt-24 pb-20 px-4 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Administration Catalogue</h1>

        <div className="bg-neutral-900 border border-white/10 p-6 rounded-xl mb-12">
          <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
            <Plus className="text-purple-400" /> Ajouter une instru
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <input 
                placeholder="Titre" required
                className="bg-black/50 border border-white/10 p-3 rounded-lg"
                value={formData.title}
                onChange={e => setFormData({...formData, title: e.target.value})}
              />
              <div className="flex gap-2">
                <input 
                  placeholder="BPM" type="number" required
                  className="bg-black/50 border border-white/10 p-3 rounded-lg flex-1"
                  value={formData.bpm}
                  onChange={e => setFormData({...formData, bpm: parseInt(e.target.value)})}
                />
                <input 
                  placeholder="Clé (ex: Cm)" required
                  className="bg-black/50 border border-white/10 p-3 rounded-lg flex-1"
                  value={formData.key}
                  onChange={e => setFormData({...formData, key: e.target.value})}
                />
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <input 
                placeholder="Prix (€)" type="number" step="0.01" required
                className="bg-black/50 border border-white/10 p-3 rounded-lg"
                value={formData.price}
                onChange={e => setFormData({...formData, price: parseFloat(e.target.value)})}
              />
              <input 
                placeholder="Tags (séparés par virgule)"
                className="bg-black/50 border border-white/10 p-3 rounded-lg"
                value={formData.tags}
                onChange={e => setFormData({...formData, tags: e.target.value})}
              />
            </div>

            <input 
              placeholder="Lien Audio (Dropbox raw=1)" required
              className="w-full bg-black/50 border border-white/10 p-3 rounded-lg"
              value={formData.audio_url}
              onChange={e => setFormData({...formData, audio_url: e.target.value})}
            />
            <input 
              placeholder="Lien Image (Drive thumbnail)" required
              className="w-full bg-black/50 border border-white/10 p-3 rounded-lg"
              value={formData.cover_image}
              onChange={e => setFormData({...formData, cover_image: e.target.value})}
            />

            <button type="submit" className="w-full bg-purple-600 hover:bg-purple-700 p-3 rounded-lg font-bold">
              Ajouter au catalogue
            </button>
          </form>
        </div>

        <div className="space-y-4">
          {beats.map(beat => (
            <div key={beat.id} className="flex items-center justify-between p-4 bg-black/40 border border-white/5 rounded-xl">
              <div className="flex items-center gap-4">
                <img src={beat.cover_image} alt={beat.title} className="w-12 h-12 object-cover rounded-md" />
                <div>
                  <div className="font-bold">{beat.title}</div>
                  <div className="text-xs text-gray-500">{beat.bpm} BPM • {beat.price}€</div>
                </div>
              </div>
              <button 
                onClick={() => handleDelete(beat.id)}
                className="p-2 bg-red-500/20 text-red-500 rounded-lg hover:bg-red-500 hover:text-white transition-colors"
              >
                <Trash className="w-5 h-5" />
              </button>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Admin;
